import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { astriskStyle } from 'src/styles/CommonStyles.styled';
import {SMALL_TEXT_PX, SECONDARY_FONT_COLOR, FONT_FAMILY_REGULAR } from '../../../styles/fonts/MCFontConstants';
export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    margin: ${({ procedureText, isFromSurgery }) =>
        isFromSurgery
            ? '0'
            : procedureText
            ? '25px 0 0 35px'
            : '15px 0 0 35px'};
    flex-direction: ${({ isFromProcedure }) =>
        isFromProcedure ? 'row' : 'column'};
    flex-wrap: ${({ isFromProcedure }) =>
        isFromProcedure ? 'nowrap;' : 'wrap'};

    ${media.mobileDevice`
    width: 100%; 
    margin: ${({ procedureText, isFromSurgery, isFromProcedure }) =>
        isFromSurgery || procedureText
            ? '0'
            : !procedureText && isFromProcedure
            ? '16px 0 0 0'
            : isFromProcedure && '16px 0 -15px 0'};
     flex-direction: ${({ isFromProcedure }) => isFromProcedure && 'row'};
    
    `}
    @media only screen and (min-width: 1023px) and (max-width: 1025px) {
        margin: ${({ isFromSurgery }) =>
            isFromSurgery ? '0' : '15px 0 0 10px'};
        flex-direction: ${({ isFromProcedure }) =>
            isFromProcedure ? 'row' : 'column'};
    }
    @media only screen and (min-width: 768px) and (max-width: 770px) {
        margin: ${({ procedureText, isFromSurgery, isFromEquity }) =>
            isFromSurgery
                ? '0'
                : procedureText
                ? '-8px 0 0 0'
                : isFromEquity
                ? '15px 0 15px 0'
                : '15px 0 0 0'};
        flex-direction: column;
    }
    @media only screen and (min-width: 820px) and (max-width: 823px) {
        margin: ${({ isFromSurgery }) =>
            isFromSurgery ? '0' : '15px 0 0 10px'};
        flex-direction: ${({ isFromProcedure }) =>
            isFromProcedure ? 'row' : 'column'};
    }
`;

export const Title = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    color: ${SECONDARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    margin-right: ${({ isFromProcedure }) => (isFromProcedure ? '10px' : '')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '8px'};
    margin-top: ${({ isFromProcedure }) =>
        isFromProcedure ? isFromProcedure : '8px'};
    @media only screen and (max-device-width: 375px) {
        margin-top: 0px;
    }
    @media only screen and (min-width: 767px) and (max-width: 1025px) {
        margin-top: 5px;
    }
    ${media.mobileDevice`
   
   width:${({ isFromProcedureScreen }) => isFromProcedureScreen && '180px'};
   margin-top: ${({ isFromProcedure }) =>
       isFromProcedure ? isFromProcedure : '0px'};
    `};
      @media only screen and (min-width: 768px) and (max-width: 1020px) {
   
      width:${({ isFromProcedureScreen }) => isFromProcedureScreen && '180px'};

  
}
    ${astriskStyle};
`;
export const RadioRowDiv = styled.span`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    margin-left: ${({ isFromProcedure }) => isFromProcedure && '20px'};
    word-break: ${({ wordBreak }) => wordBreak};
    ${media.mobileDevice`
   
        margin-right: ${({ isFromProcedure }) => isFromProcedure && '-15px'};
 margin-bottom: 8px;
    
    `};

    @media only screen and (min-width: 767px) and (max-width: 1025px) {
           margin-left: ${({ isFromProcedure }) => isFromProcedure ? '0px' : '8px'};

    }
    @media only screen and (min-width: 810px) and (max-width: 1080px) {
        margin-left: ${({ isFromProcedure }) => isFromProcedure && '15px'};
    }
    @media only screen and (min-width: 820px) and (max-width: 823px) {
        margin-left: ${({ isFromProcedure }) => isFromProcedure && '15px'};
    }
    @media only screen and (min-width: 1023px) and (max-width: 1025px) {
        margin-left: ${({ isFromProcedure }) => isFromProcedure && '15px'};
    }
    @media only screen and (min-width: 390px) and (max-width: 395px) {
        margin-left: ${({ isFromProcedure }) => isFromProcedure && '0px'};
    }
    @media only screen and (min-width: 430px) and (max-width: 435px) {
        margin-left: ${({ isFromProcedure }) => isFromProcedure && '25px'};
    }
    @media only screen and (min-width: 375px) and (max-width: 377px) {
        margin-left: ${({ isFromProcedure }) => isFromProcedure && '-8px'};
    }
`;
